import {
  CreditType,
  DirectIndexType,
  IntraAccountCashTransferDirection,
  IntraAccountStockTransferDirection,
  LoanType,
  SubAccount,
  SubAccountType,
  UserReferralDeal,
} from "../generated/graphql";
import { DirectIndexingTypeShortText } from "./directIndex";

export const getCreditActivityListItemTitle = (
  creditType: CreditType,
  inviteCodeDeal?: UserReferralDeal,
) => {
  switch (creditType) {
    case CreditType.PromoCredit:
      if (
        inviteCodeDeal &&
        inviteCodeDeal === UserReferralDeal.DiAumManagedForNoFees
      ) {
        return "Credit";
      }
      return "Referral bonus deposit";
    case CreditType.Courtesy:
    case CreditType.FeeReversal:
    case CreditType.Rebate:
    case CreditType.WriteOff:
    case CreditType.ZeroingAccount:
    default:
      return "Credit";
  }
};

export const getCreditActivityListItemReason = (
  creditType: CreditType,
  inviteCodeDeal?: UserReferralDeal,
): string | undefined => {
  switch (creditType) {
    case CreditType.PromoCredit:
      if (
        inviteCodeDeal &&
        inviteCodeDeal === UserReferralDeal.DiAumManagedForNoFees
      ) {
        return "Reward: $75k managed free";
      }
      return undefined;
    case CreditType.Courtesy:
    case CreditType.FeeReversal:
    case CreditType.Rebate:
    case CreditType.WriteOff:
    case CreditType.ZeroingAccount:
    default:
      return undefined;
  }
};

export const subAccountName: Record<SubAccountType, string> = {
  [SubAccountType.DirectIndex]: "Direct Indexing",
  [SubAccountType.Treasury]: "Treasury",
  [SubAccountType.Primary]: "Self-managed portfolio",
};

export const getSubAccountLabel = (subAccount: SubAccount) => {
  if (
    subAccount.type === SubAccountType.DirectIndex &&
    subAccount.directIndexAccountMetadata?.type
  ) {
    return `${subAccountName[subAccount.type]} - ${
      DirectIndexingTypeShortText[subAccount.directIndexAccountMetadata.type]
    }`;
  }

  return subAccountName[subAccount.type];
};

export const getSubAccountName = (
  subAccount?: {
    type: SubAccountType;
    directIndexAccountMetadata?: {
      type: DirectIndexType;
    } | null;
  } | null,
) => {
  if (!subAccount) {
    return "";
  }

  if (
    subAccount.type === SubAccountType.DirectIndex &&
    subAccount.directIndexAccountMetadata?.type
  ) {
    return `${
      DirectIndexingTypeShortText[subAccount.directIndexAccountMetadata.type]
    } index`;
  }

  return subAccountName[subAccount.type];
};

export const intraAccountCashTransferDirectionMap = {
  [IntraAccountCashTransferDirection.Allocation]: "Allocation",
  [IntraAccountCashTransferDirection.Treasury]: "Treasury",
  [IntraAccountCashTransferDirection.DirectIndex]: "Direct index",
  [IntraAccountCashTransferDirection.FrecCash]: "Cash",
};

export const intraAccountStockTransferDirectionMap = {
  [IntraAccountStockTransferDirection.DirectIndex]: "Direct index",
  [IntraAccountStockTransferDirection.Primary]: "Self-managed portfolio",
};

export const DISPLAY_LOAN_TYPES = new Set([
  LoanType.AcatsTransferredLoan,
  LoanType.LoanRepayment,
  LoanType.LoanRepaymentDividendSweep,
  LoanType.LoanRepaymentMarginInterest,
  LoanType.UserInitiated,
]);
